<template>
  <div id="app" ref="app">
    <router-view></router-view>
    <MobileFooterNav v-if="isShowFooterNav"/>
    <BackTop class="hidden-xs-only" />
  </div>
</template>

<script>
import MobileFooterNav from '@/views/h5/MobileFooterNav.vue'
import Home from '@/views/home/Home.vue'
export default {
  name: 'App',
  components: {
    Home,
    MobileFooterNav,
  },
  data() {
    return {
      isShowFooterNav: false // 默认选中首页
    };
  },
  watch: {
    $route() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    '$route.path'(newPath) {
      const routes = [
        '/sale_home', //首页
         '/sale_list',//分销返利
        '/app_home', //首页
        '/app_activation', //球杆激活
        '/app_search', //会员真伪查询
        '/app_search_dls',//代理商真伪查询
        '/unbind', //球杆解绑
        '/app_mine', //我的-个人中心
        '/app_message', //消息
        '/app_chat',
        '/app_dls_message', //消息
        '/app_dls_chat',
        '/app_myClub', //我的球杆
        '/app_after', //售后申请
        '/app_after_benefits', //售后申请
        '/app_step', //售后进度查询
        '/app_edit_info', //修改资料
        '/app_benefits', //我的权益
        '/benefits_use', //权益使用
      ];
      if(routes.indexOf(newPath)>= 0){
        this.isShowFooterNav = true;
      }else{
        this.isShowFooterNav = false;
      }
    }
  },
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
@import url('./assets/css/icon.css');
</style>
